import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-2mdghk-0"
})(["div.ant-spin.ant-spin-spinning{position:fixed;top:calc(50% - 200px);}"]);
export var ListItemContainer = styled.div.withConfig({
  displayName: "styles__ListItemContainer",
  componentId: "sc-2mdghk-1"
})(["background-color:", ";border-bottom:1px solid #f0f0f0;"], function (props) {
  return props.background ? props.background : 'white';
});